import { render } from "./EmailFormSection.vue?vue&type=template&id=b5702892&scoped=true&ts=true"
import script from "./EmailFormSection.vue?vue&type=script&lang=ts"
export * from "./EmailFormSection.vue?vue&type=script&lang=ts"

import "./EmailFormSection.vue?vue&type=style&index=0&id=b5702892&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5702892"]])

export default __exports__